import type {ChatbotWhatsappAction} from 'src/action-creators/chatbot-whatsapp';
import type {ChatbotWhatsappState} from 'src/types/chatbot-whatsapp';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';

import {
  RECEIVE_CHATBOT_WHATSAPP_INFO,
  UPDATE_CHATBOT_WHATSAPP_INFO,
  UPDATE_NODE_SCHEDULE,
  RESET,
} from 'src/action-creators/chatbot-whatsapp';


const initialState = {
  flow_id: null,
  to_number: null,
  ...getDefaultNodeScheduleState({
    blackout_action: 'SEND_BEFORE',
  }),
} as const;

export default (
  state: ChatbotWhatsappState = initialState,
  action: ChatbotWhatsappAction,
): ChatbotWhatsappState => {
  switch (action.type) {
    case UPDATE_CHATBOT_WHATSAPP_INFO:
      const updatePayload = action.payload;
      return {
        ...state,
        ...updatePayload,
      };
    case RECEIVE_CHATBOT_WHATSAPP_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case RESET:
      return {...initialState};
  }
  return state;
};
